import { Route } from '@angular/router';
import { quitterFormulaireGuard } from './quitter-formulaire.guard';

/**
 * Route du détail d'un formulaire, sous le parent `cms`.
 * `paramsOrQueryParamsChange` : un changement de `?onglet=` seul (clic sur un
 * onglet, Précédent/Suivant du navigateur) passe aussi par la garde de sortie,
 * qui est ainsi le SEUL endroit qui demande confirmation.
 */
export const formDetailRoute: Route = {
  path: 'forms/:uuid',
  loadComponent: () => import('./form-detail').then((m) => m.FormDetail),
  canDeactivate: [quitterFormulaireGuard],
  runGuardsAndResolvers: 'paramsOrQueryParamsChange',
};
